'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _currentUserSelector = require('../../currentUserSelector');

var _getAppUrl = require('../../../utils/getAppUrl');

var _getAppUrl2 = _interopRequireDefault(_getAppUrl);

var _ShareButton = require('../../../components/buttons/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _StaticURLField = require('../../../components/form/fields/StaticURLField');

var _StaticURLField2 = _interopRequireDefault(_StaticURLField);

var _ReferralList = require('./ReferralList');

var _ReferralList2 = _interopRequireDefault(_ReferralList);

var _userConstants = require('../../../../common/users/userConstants');

require('./ReferSheet.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LB = '%0D%0A';

var TWEET_BUTTON_CONTENT = "I've started using @milanoteapp, the notes app for creative work. " + 'You should too! Sign up for free:';

var getReferralURL = function getReferralURL(referrerCode) {
    return (0, _getAppUrl2.default)() + '/refer/' + referrerCode;
};

var getEmailBodyContent = function getEmailBodyContent(referralUrl, currentUser) {
    return 'Hi,' + LB + LB + '\nI\'ve been using a new app which I think you\'d like.' + LB + LB + '\nIt\'s called Milanote. It\'s a visual workspace designed to match the way creative people think.' + LB + LB + '\nSign up for free here:' + LB + '\n' + referralUrl + LB + LB + '\n' + currentUser.getIn(['name', 'givenName']);
};

var referSheetSelector = (0, _reselect.createSelector)(_currentUserSelector.getCurrentUser, function (state) {
    return state.get('users');
}, function (currentUser, users) {
    return {
        currentUser: currentUser,
        users: users,
        referrerCode: currentUser.get('referrerCode'),
        referrals: currentUser.get('referrals')
    };
});

var ReferSheet = function ReferSheet(props) {
    var referrerCode = props.referrerCode,
        users = props.users,
        currentUser = props.currentUser,
        referrals = props.referrals;

    var referralUrl = getReferralURL(referrerCode);

    return _react2.default.createElement(
        'div',
        { className: 'ReferSheet' },
        _react2.default.createElement(
            'div',
            { className: 'refer-explain' },
            _react2.default.createElement(
                'p',
                null,
                'Increase your storage by ',
                _userConstants.CONTENT_LIMIT_REFERRAL_MULTIPLIER,
                ' cards every time someone signs up using this link (up to a maximum of ',
                _userConstants.CONTENT_LIMIT_FREE_MAX,
                ')'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'refer-link' },
            _react2.default.createElement(
                'h3',
                null,
                'Your personal referral link:'
            ),
            _react2.default.createElement(_StaticURLField2.default, { url: referralUrl })
        ),
        _react2.default.createElement(
            'div',
            { className: 'refer-share' },
            _react2.default.createElement(
                'h3',
                null,
                'Share your link:'
            ),
            _react2.default.createElement(
                'div',
                { className: 'share-buttons' },
                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.TWITTER,
                    url: referralUrl,
                    defaultContent: TWEET_BUTTON_CONTENT }),
                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.FACEBOOK,
                    url: referralUrl,
                    defaultContent: 'Unlock your creativity Milanote. Sign up for free!' }),
                _react2.default.createElement(_ShareButton2.default, { service: _ShareButton.SHARE_SERVICES.EMAIL,
                    defaultContent: 'Milanote',
                    bodyContent: getEmailBodyContent(referralUrl, currentUser) })
            ),
            _react2.default.createElement(
                'div',
                { className: 'disclaimer' },
                'You\'ll get a chance to write a custom message before it\'s posted'
            )
        ),
        _react2.default.createElement(_ReferralList2.default, { referrals: referrals, users: users })
    );
};

ReferSheet.propTypes = {
    currentUser: _propTypes2.default.object,
    users: _propTypes2.default.object,
    referrals: _propTypes2.default.object,
    referrerCode: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(referSheetSelector)(ReferSheet);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/referral/ReferSheet.js
// module id = 2078
// module chunks = 0